import './Home.scss';
import { useEffect, useState } from 'react';
import HomeCarousel from './HomeCarousel';
import UserGuides from './UserGuides';
import Contribute from './Contribute';
import Support from './Support';
import RanOnboarding from './RanOnboarding';
// import Roadmap from './Roadmap';

const Home = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // simulate data, fonts, layout prep
    const timer = setTimeout(() => setIsReady(true), 100); // wait for layout readiness
    return () => clearTimeout(timer);
  }, []);

  if (!isReady) return null; // or <Loading />

  return (
    <div id="swob-home" className="home-container">
      <RanOnboarding />
      <div className="sections-container">
        <div className="home-carousel-title-section">
          <h3>Inside RLCA</h3>
          <p>Learn how to use RAN Life Cycle Automation Services (RLCA) and kept in track with the news and updates.</p>
        </div>
        <HomeCarousel />

        {/* TODO waiting for design changes*/}
        {/* <div className="home-roadmap-title-section">
          <h3>Roadmap 2025</h3>
          <p>Stay informed about upcoming features and improvements. Schedule may be subject to change.</p>
        </div>
        <Roadmap /> */}

        <div className="home-user-guides-title-section">
          <h3>User Guides</h3>
          <p>Access all the technical and operational documentation you need to install, configure, manage, and maintain the system.</p>
        </div>
        <UserGuides />

        <Contribute />

        <Support />
      </div>
    </div>
  );
};

export default Home;
